import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"width":"350","color":"secondary"}},[_c(VContainer,{attrs:{"align":"center"}},_vm._l((this.resources),function(item,id){return _c(VRow,{key:id,attrs:{"justify":"center","no-gutters":""}},[_c('Resource',{key:id,attrs:{"resource_id":id,"resource":item}})],1)}),1),_c(VRow,{attrs:{"color":"secondary"}},_vm._l((this.scenes),function(item,id){return _c('Scene',{key:id,attrs:{"scene":{...item, id}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }